import { render, staticRenderFns } from "./BankAccountItem.vue?vue&type=template&id=31f57ca9&lang=pug&"
import script from "./BankAccountItem.vue?vue&type=script&lang=js&"
export * from "./BankAccountItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports